const REQUEST_PLAYERS = '@@players/REQUEST_PLAYERS';
const PLAYERS_RESPONSE = '@@players/PLAYERS_RESPONSE';
const FLUSH_CACHE = '@@players/FLUSH_CACHE';

export default {
    REQUEST_PLAYERS,
    PLAYERS_RESPONSE,
    FLUSH_CACHE
};